module.exports = __webpack_public_path__ + "img/zh.68fcf91f.png";